import PlpModal from "./PlpModal";

export default PlpModal;
